angular.module('aprima-provider-api').factory('VisitRepository',
    ['AprimaRestangular', 'AprimaAnalytics', '$rootScope', function (AprimaRestangular, AprimaAnalytics, $rootScope) {
        'use strict';

        return {
            getVisit: getVisit,
            getVisitDetail: getVisitDetail,
            getVisitDocument: getVisitDocument,
            createVisit: createVisit,
            getVisitByAppointment: getVisitByAppointment,
            getVisitDocumentForVisitText: getVisitDocumentForVisitText,
        };

        function getVisit(patientId, visitId) {
            var timing = AprimaAnalytics.startTiming('VisitRepository', 'api', 'get visit info');
            var restangular = AprimaRestangular.get();
            return restangular
                .one('patients/' + patientId + '/visits/' + visitId)
                .get()
                .finally(timing.stop);
        }

        function getVisitDetail(visitId) {
            var timing = AprimaAnalytics.startTiming('VisitRepository', 'api', 'get visit detail');
            var restangular = AprimaRestangular.get();
            return restangular
                .one('visits/' + visitId)
                .get()
                .finally(timing.stop);
        }

        function getVisitDocument(patientId, visitId) {
            var timing = AprimaAnalytics.startTiming('VisitRepository', 'api', 'get visit document');
            var restangular = AprimaRestangular.get();
            return restangular
                .one('patients/' + patientId + '/visits/' + visitId + '/document')
                .get()
                .finally(timing.stop);
        }

        function createVisit(visit) {
            var timing = AprimaAnalytics.startTiming('VisitRepository', 'api', 'create visit');
            var restangular = AprimaRestangular.get();
            return restangular
                .all('visits')
                .post(visit)
                .finally(timing.stop)
                .finally(function() {
                    $rootScope.$emit('visit-updated', {patientId: visit.Patient.Id});
                });
        }

        function getVisitByAppointment(appointmentId) {
            var timing = AprimaAnalytics.startTiming('VisitRepository', 'api', 'get appointment visit');
            var restangular = AprimaRestangular.get();
            return restangular
                .one('visit-appointment/' + appointmentId)
                .get()
                .finally(timing.stop);
        }

        function getVisitDocumentForVisitText(patientId, visitId) {
            var timing = AprimaAnalytics.startTiming('VisitRepository', 'api', 'get visit document for visit text');
            var restangular = AprimaRestangular.get();
            return restangular
                .one('patients/' + patientId + '/visits/' + visitId + '/documentvisittext')
                .get()
                .finally(timing.stop);
        }
    }]);

